export default __webpack_public_path__ + "static/media/Planning300.4d63bbae.jpg";